import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Link: ComponentStyleConfig = {
  baseStyle: {
    _hover: {
      textDecoration: 'none',
    },
    shadow: 'none',
  },
};

export default Link;
